import React, { useEffect, useState } from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import { InformacionFuncionario } from "../../components/EtapasDeCalificacion/InformacionFuncionario";
import { ModalDocumento } from "../../components/Otros/ModalDocumento";
import { cargarCalificacionFinal } from "../../utils/Datos";

export const CalificacionFinal = ({ id_participant = null }) => {
  const [datosCalificacionFinal, setdatosCalificacionFinal] = useState(null);
  
  
  useEffect(() => {
    cargarCalificacionFinal(id_participant).then((calificacionfinal) => {
      if (calificacionfinal.status) {
        setdatosCalificacionFinal(calificacionfinal);
      }else{
        setdatosCalificacionFinal(null);
      }
    });
  }, []);

  return  datosCalificacionFinal !==null ?
    <div className="col-xl-12 mt-5">
      <h4 className="text-gray-900 fw-bolder">CALIFICACIÓN FINAL</h4>
      <div className="table-responsive">
        <table className="table table-rounded table-striped border gy-7 gs-7">
          <thead>
            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200 ">
              <th>SF11</th>
              <th>SF12</th>
              <th>NOTA</th>
              <th>PTJE F1</th>
              <th>SF21</th>
              <th>SF22</th>
              <th>SF23</th>
              <th>NOTA</th>
              <th>PTJE F2</th>
              <th>SF31</th>
              <th>SF32</th>
              <th>NOTA</th>
              <th>PTJE F3</th>
              <th>FINAL</th>
              <th>LISTA</th>
            </tr>
          </thead>
          <tbody>
            {datosCalificacionFinal.datos === null ||
            datosCalificacionFinal.status === false ? (
              <tr>
                <td colSpan={17} className="text-center">
                  No se encontraron datos
                </td>
              </tr>
            ) : (
              <tr key={`tr_calificacionfinal`}>
                <td>{datosCalificacionFinal.datos.subFactor11}</td>
                <td>{datosCalificacionFinal.datos.subFactor12}</td>
                <td>{datosCalificacionFinal.datos.qualificationFactor1}</td>
                <td>{datosCalificacionFinal.datos.scoreFactor1}</td>
                <td>{datosCalificacionFinal.datos.subFactor21}</td>
                <td>{datosCalificacionFinal.datos.subFactor22}</td>
                <td>{datosCalificacionFinal.datos.subFactor23}</td>
                <td>{datosCalificacionFinal.datos.qualificationFactor2}</td>
                <td>{datosCalificacionFinal.datos.scoreFactor2}</td>

                <td>{datosCalificacionFinal.datos.subFactor31}</td>
                <td>{datosCalificacionFinal.datos.subFactor32}</td>
                <td>{datosCalificacionFinal.datos.qualificationFactor3}</td>
                <td>{datosCalificacionFinal.datos.scoreFactor3}</td>
                <td>{datosCalificacionFinal.datos.finalScore}</td>
                <td>{datosCalificacionFinal.datos.list}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="card-footer d-flex justify-content-end py-6 px-9">
        <button
          data-bs-toggle="modal"
          data-bs-target="#modalCalificacionFinal"
          className="btn btn-success fw-bold"
        >
           VER DOCUMENTO
        </button>
      </div>

      <ModalDocumento
        id="modalCalificacionFinal"
        documentoByte={
          datosCalificacionFinal.datos !== null
          &&
          datosCalificacionFinal.datos.qualificationDocument !=null
            ? datosCalificacionFinal.datos.qualificationDocument.contentByte
            : null
        }
      />
    </div>
    : <></> 
  }
  

